export default {
  "head": "_head_16fne_1",
  "card": "_card_16fne_4"
};import "ni:sha-256;bBE8AO5PwqFqyLvRtBJgdM4pn15TfwZwYwsoG_7CURI";